var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.details.title),expression:"details.title"}],staticClass:"pd-badge has-text-centered"},[_vm._v(" "+_vm._s(_vm.details.label)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }